<template>
  <div>
    <div class="mian" v-loading="loading">
      <el-table
        :data="getData1"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column width="80" type="index" label="序号">
        </el-table-column>
        <el-table-column prop="Style" label="题型" width="120">
        </el-table-column>
        <el-table-column label="题干">
          <template slot-scope="scope">
            <!-- <p v-html="scope.row.Title"></p> -->
            <p
              v-html="referimg(scope.row.Title, 'Title', scope.row.PaperTestID)"
            ></p>
          </template>
        </el-table-column>

        <el-table-column label="正确答案" width="380">
          <template slot-scope="scope">
            <p
              v-html="
                referimg(scope.row.Answer, 'Answer', scope.row.PaperTestID)
              "
            ></p>

            <!-- <p v-html="scope.row.Answer"></p> -->
          </template>
        </el-table-column>
        <el-table-column prop="StudentAnswer" label="考生答案" width="250">
        </el-table-column>
        <el-table-column prop="Score" label="分值" width="54">
        </el-table-column>
        <el-table-column label="得分" width="160" prop="input">
          <template slot-scope="scope">
            <div class="score_input">
              <el-input
                :ref="'score_input' + scope.row.ExamResultDetailID"
                maxlength="4"
                v-model="scope.row.input"
                @blur="judgeValue(scope.row, scope.$index)"
                @focus="getfocus(scope.row)"
                :class="
                  scope.row.Score < scope.row.input || scope.row.input == ''
                    ? 'red'
                    : ''
                "
                :disabled="
                  scope.row.StudentAnswer === '未答' ||
                  scope.row.StudentAnswer == ''
                "
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 合计 -->
      <div class="combined">
        <p>合计</p>
        <div class="combined_right">
          <p>{{ comScore }}分</p>
          <p>{{ comScoreTow }}分</p>
        </div>
      </div>
      <!-- 提交按钮 -->
      <div class="submit_btn">
        <el-button class="succ_btn" @click="backClick">返回</el-button>
        <el-button class="submit_btn" :loading="sundflag" @click="addSubmit"
          >提交成绩</el-button
        >
      </div>
    </div>
    <div class="everywhere">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <p>分数设置不能为空,且得分必须小于小题分值</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getTKJDTest, updateSubjectiveScore } from "@/api/index.js";
import loginvuex from "@/store/index";
import qs from "qs";
export default {
  data() {
    return {
      isreadyonlynul: "",
      getData1: [],
      TestJson: {},
      fang: true,
      input: "",
      dataArr: [],
      topicData: {},
      loading: true,
      comScore: "", // 计算分值
      comScoreTow: "", // 计算得分
      dialogVisible: false, //分值拦截弹窗
      inputStabe: "",
      warningStabe: false, //input为空红色边框
      sundflag: false, // 提交成绩防抖
      disabledShow: "", // 用于拦截最后一个打分比分值高
      isShow: false,
    };
  },
  props: ["statePopupstatus", "students", "cutcoms", "backClick"],
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },

    // 处理数据TestJSON
    dealData() {
      let newarr = this.getData1.map((item, index) => {
        let TestJson = [];
        try {
          TestJson = JSON.parse(item.TestJSON);
        } catch (error) {
          TestJson = JSON.parse(item.TestJSON.replace(/‘/g, '"'));
        }
        item.Answer = TestJson.Answer;
        item.Sorting = TestJson.Sorting;
        item.Title = TestJson.Title;
        this.$set(item, "input", "");
        return item.Score;
      });
      if (this.students.IsRead == 1) {
        this.getData1.map((item) => {
          item.input = item.StudentSocre;
        });
      }
      if (this.getData1 != "") {
        this.comScore = newarr.reduce((x, y) => x + y);
      }
    },
    // 提交警告
    intercept() {
      this.$confirm("当前操作提交完成绩后不能再次批阅，是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.addSubmit();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 拦截校验
    addSubmit() {
      this.getData1.forEach((item) => {
        this.inputStabe = item.input;
      });
      // 便利input，如果有没打分的就返回，没有的话就放回undefined
      let isflase;
      this.getData1.forEach((item) => {
        if (
          item.Score < item.input ||
          item.input === undefined ||
          item.input === ""
        ) {
          isflase = true;
          this.dialogVisible = true;
        }
      });
      if (!isflase) {
        this.submitData();
      }
      // let index = this.getData1.find((item) => {
      //   return item.input === "" || item.input === null;
      // });
      // if (index === undefined) {
      //   if (this.disabledShow == 1) {
      //     // 如果得分应小于小题的分值拦截
      //     this.dialogVisible = true;
      //   } else if (this.disabledShow == 2) {
      //     // 放行
      //     this.submitData();
      //   }
      // } else {
      //   // 为空拦截
      //   this.dialogVisible = true;
      // }
    },
    // 处理提交数据
    submitResults() {
      this.getData1.forEach((item) => {
        let data_obj = {
          paperTestID: item.PaperTestID,
          score: item.input,
          totalScore: item.Score,
          ExamResultDetailID: item.ExamResultDetailID,
        };
        this.dataArr.push(data_obj);
      });
    },
    // 提交成绩
    async submitData() {
      this.submitResults(); // 数据处理
      this.sundflag = true;
      let params = {
        examID: Number(sessionStorage.getItem("studRow")),
        studentUserID: Number(sessionStorage.getItem("examRow")),
        scoreArr: JSON.stringify(this.dataArr),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await updateSubjectiveScore(qs.stringify(params));
      if (Data.status === 200) {
        this.$message({
          message: "恭喜你，提交成绩成功!",
          type: "success",
        });
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.$parent.isread = 0;
        this.backClick();
        // this.$destroy(); // 摧毁当前页面
        // this.cutcoms(1);
        // this.$destroy();
      } else {
        this.$message.error(Data.Msg);
        this.sundflag = false;
      }
    },
    // 聚焦获取当前对象
    getfocus(item) {
      this.topicData = item; //当前的对象
    },
    // 输入分值大于时拦截
    judgeValue(row) {
      var reg = /^[0-9]+.?[0-9]*$/; // 数字类型
      var regPos = /^\d+(\.\d+)?$/; // 携带小数点
      if (this.topicData.input) {
        if (this.topicData.Score < this.topicData.input) {
          this.$refs["score_input" + this.topicData.ExamResultDetailID].focus();
          this.disabledShow = 1; //按钮禁用
          this.warningStabe = true;
          this.$message.warning("注意！ 得分应小于小题的分值！");
        } else if (!regPos.test(row.input)) {
          // 如果当前输入不是数字整数直接清空当前
          row.input = "";
          this.$message.warning("注意！ 得分只能输入数字");
        } else {
          this.disabledShow = 2; // 按钮开启
        }
      } else if (this.topicData.input === "" || this.topicData.input === null) {
        this.$refs["score_input" + this.topicData.ExamResultDetailID].focus();
        this.$message.warning("分值不能为空,为得分打0分!");
      } else if (reg.test(row.input)) {
      }

      // 计算
      let res = this.getData1.map((item) => {
        let zitem = item.input * 1;
        return zitem;
      });
      this.comScoreTow = res.reduce((x, y) => x + y);
      // this.computedNum()
    },
    async addTkjdTest() {
      let params = {
        examID: sessionStorage.getItem("studRow"),
        sudentUserID: sessionStorage.getItem("examRow"),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await getTKJDTest(params);
      if (Data.status === 200) {
        // this.getData1 = add.Data.data;
        this.getData1 = Data.data.Data.data;
        this.getData1.map((item) => {
          // 遍历去除[]
          if (item.TestJSON != null) {
            try {
              item.StudentAnswer = JSON.parse(item.StudentAnswer).join(",");
            } catch {
              //
            }
            // if (item.StudentAnswer.indexOf("[") != "-1" && JSON.parse(item.StudentAnswer) instanceof Array === true) {
            //   .join(",");
            // }
          }
          // item.Answer = JSON.parse(item.Answer).join(",")
          // item.
          if (item.StudentAnswer == null || item.StudentAnswer == "") {
            item.StudentAnswer = "未答";
          }
        });
        this.dealData();
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(Data.data);
      }
    },

    // 计算分数总和
    computedNum() {
      let res = this.getData1.map((item) => {
        let zitem = item.input * 1;
        return zitem;
      });
      if (this.getData1.length != 0) {
        this.comScoreTow = res.reduce((x, y) => x + y);
      }
    },
    // 限制未答时分值为空
    limitScore() {
      this.getData1.map((item) => {
        if (item.StudentAnswer === "未答") {
          item.input = "0"; // 如果未答的题，默认分值打0分
        }
      });
      // 有主观阅题一个没做的情况下判断按钮状态
      let index = this.getData1.find((item) => {
        return item.input == "" || item.input == null;
      });
      if (index == undefined) {
        this.disabledShow = 2; // 都有分值的情况默认通过
      } else {
        this.disabledShow = 1; // 初始进来有空值的话就禁用提交
      }
    },
  },
  computed: {
    // //图片处理 下标处理
    referimg() {
      return function (params, text, id) {
        if (text == "Title") {
          if (params.indexOf("[Img") == "-1") {
            return params; // 不需要处理的直接返回
          } else {
            let a = params.replace(
              /\[Img/g,
              "<img src='https://testimages.ksbao.com/tk_img/Img"
            );
            if (a.indexOf("~") != "-1") {
              let codeindex = a.lastIndexOf(".");
              a = a.replace(
                a[codeindex - 1],
                "%" + a[codeindex - 1].charCodeAt().toString(16)
              );
            }
            // 如果试卷ID超过或等于32位 http://customimgt.tibosi.com/hospitalID/XXX.gif
            if (String(id).length >= 32) {
              let imgurl = sessionStorage.getItem("ImgUrl"); // 图片正式还是测试地址
              a = params.replace(
                /\[Img/g,
                `<img src='${imgurl}/${JSON.parse(loginvuex.state.hid)}/`
              );
            }
            return a.replace(/\]/g, "'>");
          }
        } else if (text == "Answer") {
          // 答案返回数据单独处理
          if (params instanceof Array !== true) {
            params = [params];
          }
          if (params[0].indexOf("[Img") == "-1") {
            return params;
          } else {
            let a = params[0].replace(
              /\[Img/g,
              "<img src='https://testimages.ksbao.com/tk_img/Img"
            );
            if (a.indexOf("~") != "-1") {
              let codeindex = a.lastIndexOf(".");
              a = a.replace(
                a[codeindex - 1],
                "%" + a[codeindex - 1].charCodeAt().toString(16)
              );
            }
            if (String(id).length >= 32) {
              let imgurl = sessionStorage.getItem("ImgUrl"); // 图片正式还是测试地址
              a = params.replace(
                /\[Img/g,
                `<img src='${imgurl}/${JSON.parse(loginvuex.state.hid)}/`
              );
            }
            return a.replace(/\]/g, "'>");
          }
        }
      };
    },
    // + 处理
    isreferimg() {
      return function (params) {
        if (params.indexOf("[Img") == "-1") {
          return params;
        } else {
          let a = params.replace(
            /\[Img/g,
            "<img src='https://testimages.ksbao.com/tk_img/Img"
          );
          a = a.replace(/\~\+/g, "~%2B");
          return a.replace(/\]/g, "'>");
        }
      };
    },
  },
  updated() {
    this.limitScore(); // 限制未答时分值为空
    this.computedNum();
  },
  activated() {
    this.addTkjdTest();
    // console.log("主观阅题");
  },
  created() {
    this.sundflag = false;
    // this.addTkjdTest();
  },
};
</script>

<style lang="scss" scoped>
// 分页
.footBox {
  position: relative;
  height: 110px;
  .footPage {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      &::before {
        content: "10条/页";
        width: 82px;
        border: 1px solid #d9d9d9;
        height: 28px;
        border-radius: 2px;
        text-align: center;
        display: inline-block;
        margin-right: 8px;
        cursor: pointer;
      }
    }
  }
}
.scoll {
  height: 280px;
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.score_input {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-input__inner {
  width: 56px;
  height: 34px !important;
}
.mian {
  margin-top: 10px;
}
// 弹窗样式
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    height: 220px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  p {
    text-align: center;
    font-size: 16px;
  }
}
// 提交按钮
.submit_btn {
  display: flex;
  justify-content: center;
  align-items: center;

  > .el-button {
    width: 162px;
    height: 50px;
    margin: 50px 0px 50px 0px;
    &:nth-child(1) {
      background: #eeeeee;
      color: #999999;
    }
    &:nth-child(2) {
      background: #0fc758;
      color: #ffffff;
      margin-left: 90px;
    }
  }
}
::v-deep .el-pagination__editor.el-input {
  width: 61px;
}
.combined {
  border: 1px solid #eeeeee;
  height: 60px;
  border-top: none !important;
  line-height: 60px;
  padding: 0px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    font-size: 18px;
    font-weight: bolder;
    letter-spacing: 2px;
  }
  .combined_right {
    display: flex;
    p {
      text-align: center;
      height: 60px;
      &:nth-child(1) {
        min-width: 54px;
      }
      &:nth-child(2) {
        min-width: 130px;
      }
    }
  }
}
::v-deep .red > .el-input__inner {
  &:focus {
    border-color: red !important;
  }
}
// 表格超出滚动
.mian {
  ::v-deep .el-table__body-wrapper {
    height: 700px;
    overflow-y: scroll;
  }
}
</style>
